<!--
 * @Author: your name
 * @Date: 2020-12-11 11:14:39
 * @LastEditTime: 2020-12-16 22:02:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-update-info/index.vue
-->
<style scoped lang="sass">
.container
  width: 100%
  padding: 0 17px
  margin-top: 20px

.footer_common
  position: fixed
  bottom: 0
  left: 0

.info
  margin-top: 10px
  margin-bottom: 100px
  line-height: 17px
  font-size: 13px
  color: var(--menu-primary-text-colour)

.time_select
  display: flex
  justify-content: space-between
  align-content: center

.date_field
  margin-right: 30px

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .van-field__control
    color: var(--menu-primary-text-colour)
    opacity: .8
</style>

<template lang="pug">
.container
  van-form.__form_component(ref="form")
    input-field(
      disabled
      v-model="tabDetailInfo.name"
      name="Name"
      :rules="[{ required: true, message: 'Name is required' }]"
    )

    input-field.mt30(
      v-model="tabDetailInfo.email"
      name="Email Address"
      type="email"
      :rules="[{ required: true, message: 'Email Address is required' }, { validator: this.validateEmail, message: 'Format of email is incorrect' }]"
      tip="Your tax invoice will be sent here along with an itemised account."
    )

    input-field.mt30(
      v-model="tabDetailInfo.phone"
      name="Phone number"
      type="tel"
      :rules="[{ required: true, message: 'Phone number is required' }, { validator: this.validatePhone, message: 'Format of phone is incorrect' }]"
      tip="You will be notified when your tab is approaching its limit."
    )

    .time_select.mt30
      date-field.flex1.date_field(
        v-model="tabDetailInfo.openDateTime.date"
        name="Tab open date"
        disabled
      )

      time-field.flex1(
        v-model="tabDetailInfo.openDateTime.time"
        name="Tab open time"
        disabled
      )
    input-field.mt30(
      v-model="tabDetailInfo.tabAmount"
      dollarIcon
      type="digit"
      name="Tab amount"
      label-width="3px"
      :rules="[{ required: true, message: 'Tab amount is required' },{ validator: tabAmountValidator, message: `Tab amount must be more than ${this.tabDetailInfo.minAmount}`},{ validator: tabAmountValidator, message: `Tab amount must be more than ${this.tabDetailInfo.minAmount}`}]"
    )
    .info
      span.o6 The minimum amount for your tab is
      span.b.o7 {{ ' $' }}{{ tabDetailInfo.minAmount | fix }}{{ '. ' }}
      span.o6 You will be charged (at least) this amount when the tab is closed.

  footer-common.footer_common.b(
    :text="text"
    @clickButton="handleSubmit"
  )

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import InputField from '../../components/input-field'
import DateField from '../../components/date-field'
import TimeField from '../../components/time-field'
import { emitLoading } from 'utils/decorators'
import { t } from '@/utils/language'
import { formatDecimalNumber } from '@/utils/currency'

@Component({
  filters: {
    fix(val) {
      return val ? formatDecimalNumber(val) : formatDecimalNumber(0)
    }
  },

  components: {
    InputField,
    DateField,
    TimeField,
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    },

    tabDetail: {
      type: Object
    }
  },

  computed: {
    tabDetailInfo: {
      get() {
        return this.tabDetail
      },
      set(val) {
        this.tabDetail = val
      }
    }
  }
})

class TabInputInfo extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  text = t('continue', 'CONTINUE')

  tabAmountValidator(val) {
    const isNumber = /^\d+$/.test(val)
    const moreThanMinTapAmount = parseInt(val) >= this.tabDetailInfo.minAmount
    const res = isNumber && moreThanMinTapAmount
    return res
  }

  validatePhone(val) {
    const isNumber = /^\d+$/.test(val)
    const lengthMoreThan6 = val.length >= 6
    const res = isNumber && lengthMoreThan6
    return res
  }

  validateEmail(val) {
    const res = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val)
    return res
  }

  @emitLoading('input')
  async handleSubmit() {
    try {
      await this.$refs.form.validate()
      this.closeLoading()
      this.jumpToTabPayment()
    } catch (error) {
      console.error(error)
      this.closeLoading()
    }
  }

  closeLoading() {
    this.$emit('input', false)
  }

  jumpToTabPayment() {
    this.$router.push(`/v/${this.venueId}/tab-admin/${this.tabId}/payment`)
  }
}

export default TabInputInfo
</script>
